// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {395: "9b5fc20140d227de",430: "2233154c88d2986c",835: "85802a4071f1d926",}[chunkId] + ".css"
}